import { Button, Form, Input, Modal, Select } from "antd";
import { Spin } from "antd/lib";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { GetAllPerfCyclesApi } from "../../api/GetAllPerfCyclesApi";
import { perfCycleDetails } from "../../features/PerfCycleSlice";
import { LoadingOutlined } from "@ant-design/icons";
import moment from "moment";
import { setTopPlan } from "../../features/TopPlanSlice";
import ChangeLastViewedPerfCycleApi from "../../api/perf-cycles/ChangeLastViewedPerfCycleApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

function SwitchPerfCycleModal(props) {
  const [submit, setSubmit] = useState(false);
  const [cycles, setCycles] = useState([]);
  const [allCycles, setAllCycles] = useState([]);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  function handleCancel() {
    props.handleCancel();
    setCycles([]);
    setAllCycles([]);
    setSubmit(false);
  }

  useEffect(() => {
    if (props.visible) {
      getPerfCycles();
    }
  }, [props.visible]);

  async function getPerfCycles() {
    const apiResponse = await GetAllPerfCyclesApi();
    if (apiResponse.success) {
      setCycles(apiResponse.data);
      setAllCycles(apiResponse.data);
    }
  }

  function selectStatus(value) {
    let oldCycles = allCycles;
    let newCycles = [];

    if (value === "All") {
      setCycles(allCycles);
    } else {
      oldCycles.forEach((cycle) => {
        if (cycle.status === value) {
          newCycles.push(cycle);
        }
      });
      setCycles(newCycles);
    }
  }

  async function onFinish(values) {
    setSubmit(true);

    cycles.forEach((cycle) => {
      if (cycle.id === values.cycle) {
        dispatch(perfCycleDetails(cycle));
        dispatch(setTopPlan(cycle?.topPlanLevelName));
      }
    });
    const apiResponse = await ChangeLastViewedPerfCycleApi(values.cycle);
    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", `Performance cycle changed`);
      navigate(`/metabase`);
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't change performance cycle. Try again later."
      );
    }
    handleCancel();
  }

  return (
    <Modal
      title={"Change perf cycle"}
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="basic"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        initialValues={{
          status: "All",
        }}
        requiredMark={false}
      >
        <Form.Item label="Status" name="status">
          <Select
            onSelect={(value) => selectStatus(value)}
            placeholder="Select status"
          >
            <Option value="All">All</Option>
            <Option value="Scheduled">Scheduled</Option>
            <Option value="Active">Active</Option>
            <Option value="Completed">Completed</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Cycle"
          name="cycle"
          rules={[
            {
              required: true,
              message: "Please select a cycle",
            },
          ]}
        >
          <Select
            allowClear
            showSearch
            placeholder="Select cycle"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {cycles.map((cycle) => {
              return (
                <Option key={cycle.id} cycle={cycle.id}>
                  {cycle.name +
                    " (" +
                    moment(cycle.startingOn).format("DD.MM.YYYY") +
                    " - " +
                    moment(cycle.endingOn).format("DD.MM.YYYY") +
                    ")"}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="w-32"
              type="primary"
              htmlType={submit && "submit"}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Change Cycle"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default SwitchPerfCycleModal;
